import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import Hero from "src/components/hero/Hero";
import FeatureSection from "src/components/FeatureSection";
import WhatWeSupport from "src/components/WhatWeSupport";
import WhatWeOffer from "src/components/WhatWeOffer";
import TestimonialSection from "src/components/TestimonialSection";
import CtaSection from "src/components/CtaSection";
import { useAuth } from "src/context/AuthContext";

const Index = () => {

  const { user } = useAuth();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <WhatWeOffer />
        <FeatureSection />
        <WhatWeSupport />
        <TestimonialSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;



